export const DisclaimerBar = () => (
  <div
    data-testid="disclaimer-bar"
    className="w-full bg-ink text-white font-mono text-[11px] sm:text-xs px-4 py-2 border-t border-ink"
    style={{ letterSpacing: "0.04em" }}
  >
    <span className="uppercase tracking-[0.2em] mr-3 text-white/75">Notice</span>
    This tool is for educational and issue-identification purposes only. It does
    not constitute legal advice and does not create an attorney-client
    relationship.
  </div>
);

export const DisclaimerBlock = () => (
  <div
    data-testid="disclaimer-block"
    className="border border-ink bg-paper2 px-5 py-4 font-mono text-xs leading-relaxed"
  >
    <div className="uppercase tracking-[0.2em] text-[11px] text-ink/75 mb-2">
      Statutory Notice
    </div>
    This tool is for educational and issue-identification purposes only. It does
    not constitute legal advice and does not create an attorney-client
    relationship. Jurisdictional authorities are named for issue-identification
    only; this memorandum does not render comparative analysis across
    jurisdictions and does not opine on how any named authority would apply its
    rules to the facts described.
  </div>
);
